import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {
  clearEmployeeDetails,
  getEmployeeDetails,
  updateEmployee,
  addEmployee,
} from "redux/actions/EmployeesAction";
import { fetchCompanyDetails } from "redux/actions/companyAction";
import CommonMultiForm from "components/commonMultiForm/CommonMultiForm";
import CommonButton from "components/commonButton/CommonButton";
import Loader from "components/loader/Loader";
import { rolesEnum } from "utils/enumObj";
import { getCountryCode } from "redux/actions/authAction";
import { addingEmployeeForm } from "./FrontDeskData";

const FrontDeskAddingEmployee = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userProfile =  useSelector((state) => state?.userProfile?.profileDetails?.data);

  const details = useSelector(
    (state) => state?.getEmployeeDetails?.employeeDetails?.data
  );
  const defautValues = {
    companyEmployeeEmail:details?.email,
    name:details?.name,
    countryCode: details?.countryCode,
    phoneNumber:details?.phoneNumber,
    employeeId:details?.employeeId,
    code:details?.code,
    role:details?.role,
    branchName:details?.branchId,
    employeeType:"newemployee"
  }

  const role = localStorage?.getItem('role');
  const companyID = localStorage.getItem("subCompany")?.length > 0 && JSON.parse(localStorage.getItem("subCompany"));

  useEffect(() => {
    dispatch(
      fetchCompanyDetails({ id: companyID?.value, type: "newBooking" })
    );
    dispatch(getCountryCode());
  }, [])
  

  const selectedCompanyDetails = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails
  );

  const branchOption = selectedCompanyDetails && selectedCompanyDetails?.branch?.map((val) => {
    return { value: val?.id, label: val?.address };
  });

  const employeeDetailsLoader = useSelector(
    (state) => state?.getEmployeeDetails?.loading
  );

  const selectedCompanyLoader = useSelector(
    (state) => state?.userCompanyDetails?.loading
  );

  const [edit, setEdit] = useState(false);

    const countryCodeListResponse = useSelector((state) => state?.getCountryCode);
    const countryCodeListData = countryCodeListResponse?.countryCodeList?.data?.map((data) => {return {label: `${data?.code}`, value: `+${data?.dialCode}`}})

  useEffect(() => {
    if (location?.state?.id) {
      dispatch(getEmployeeDetails(location?.state?.id));
      setEdit(true);
      return () => {
        dispatch(clearEmployeeDetails());
      };
    }
  }, [location?.state?.id]);

  const formSubmit = (data,country) => {
    const employeeData = {
      companyId: companyID?.value,
      name: data?.name,
      countryCode: country,
      phoneNumber: data?.phoneNumber,
      email: data?.companyEmployeeEmail,
      employeeId: data?.employeeId,
      code: data?.code,
      role: data?.role,
      branchId: data?.branchName
    };

    if (location?.state?.type === "edit") {
      dispatch(updateEmployee(employeeData, details?.id, navigate));
    } else {
      dispatch(addEmployee(employeeData, navigate));
    }
  };

  const handleNavigate = () => {
    if (rolesEnum.frontdeskRoles?.includes(Number(userProfile?.role))) {
      navigate("/front-desk/employeeProfiles")
    } else {
      navigate("/front-desk/all")
    }
  }

  return (
    <Grid container justifyContent={"center"} className="bgLightBlue br20">
      <Grid item xs={11} lg={11} className="ptb30">
        <Grid container justifyContent={"space-between"}>
          <Box className="justifyStart pb20">
            <ArrowBackIosRoundedIcon
              className="font24 colorGrey mr10"
              role="presentation"
              onClick={handleNavigate}
            />

            <Typography
              variant="head3"
              component={"h1"}
              className={`colorBlack fw600`}
            >
              {location?.state?.profile
                ? "Profile Details"
                : location?.state?.type === "edit"
                ? "Employee Details"
                : "Enter Employee Details"}
            </Typography>
          </Box>

          {edit && role === '2' && !location?.state?.profile && (
            <CommonButton
              name={"Edit"}
              iconType={"edit"}
              iconPlace="front"
              btnClass={`btnSm btnEdit`}
              onClick={() => setEdit(!edit)}
            />
          )}
        </Grid>
        {!location?.state?.type && branchOption && (
          <CommonMultiForm
            formData={addingEmployeeForm(branchOption)}
            onSubmittBtn={formSubmit}
            button={"Submit"}
            userProfile={userProfile}
            defaultValues={defautValues}
            countryCodeListData={countryCodeListData}
          />
        )}

        {location?.state?.type === "edit" && (
          <>
            {!employeeDetailsLoader && !selectedCompanyLoader && branchOption && countryCodeListData && countryCodeListData.length > 0 ? (
              <CommonMultiForm
                formData={addingEmployeeForm(branchOption)}
                onSubmittBtn={formSubmit}
                button={!edit && "Submit"}
                userProfile={userProfile}
                resetForm={true}
                defaultValues={defautValues}
                disabled={edit || false}
                countryCodeListData={countryCodeListData}
              />
            ) : (
              <Loader />
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default FrontDeskAddingEmployee;
